import React from "react";
import PropTypes from "prop-types";

// Hooks
// import Apphook from "../app-my-click-and-post/src/hooks/appHook";

// styles
import ExternalLinkStyled from "./ExternalLink.styled";

const ExternalLink = props => {
    const { to, text, className, active, onClick, icon, activeIcon, altText, onMouseEnter, onMouseLeave, target } = props;

    return (
        <ExternalLinkStyled onClick={onClick} className={`${className}`} href={to} target={target} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
            {!active ? (
                <span>
                    <img className="sidenav__icon" src={icon} alt={altText} />
                </span>
            ) : (
                <span>
                    <img className="sidenav__icon" src={activeIcon} alt={altText} />
                </span>
            )}
            <p>{text}</p>
        </ExternalLinkStyled>
    );
};

export default ExternalLink;

// props validation
ExternalLink.propTypes = {
    to: PropTypes.string,
    text: PropTypes.string,
    className: PropTypes.string,
    active: PropTypes.bool,
    onClick: PropTypes.func,
    icon: PropTypes.string,
    activeIcon: PropTypes.string,
    altText: PropTypes.string,
    target: PropTypes.string,
    onMouseEnter: PropTypes.func,
    onMouseLeave: PropTypes.func
};
